<div>
    <span [ngStyle]="inputStyles">{{formattedTime}}</span>
</div>
